import {EventEmitter} from '@angular/core';
import {PaymentMethod} from '../consts/payment-method.enum';

export class Ga4CustomEventsHelper {
    static buyOnlineFromPresentationEvent: EventEmitter<void> = new EventEmitter<void>();
    static sortOffersSelectClickEvent: EventEmitter<void> = new EventEmitter<void>();
    static paymentInitEvent: EventEmitter<PaymentMethod> = new EventEmitter<PaymentMethod>();
    static recalculationEvent: EventEmitter<PaymentMethod> = new EventEmitter<PaymentMethod>();
}
